import { render } from "./dashboardLayout.vue?vue&type=template&id=2197f3a7"
import script from "./dashboardLayout.vue?vue&type=script&lang=js"
export * from "./dashboardLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__